export const ADD_CONSULTA = "ADD_CONSULTA";
export const ADD_IMAGENES = "ADD_IMAGENES";
export const CLEAR_DATA_GPC = "CLEAR_DATA_GPC";
export const LINK_EXPIRED = "LINK_EXPIRED";


export const addDataConsulta = (data) => {
    const { linkExpired } = data;

    return {
        type: ADD_CONSULTA,
        gpc: {
            ConsultaMedicoServicio: {
                ...data, ...{ NombreFamiliar: data.NombreFamiliar.replaceAll("@", "").trim() }
            },
            linkExpired: linkExpired
        },
    }
};

export const addImagenes = (imagenes) => (
    {
        type: ADD_IMAGENES,
        payload: {
            imagenes: imagenes
        }
    }
);

export const clearDataGpc = () => (
    {
        type: CLEAR_DATA_GPC
    }
);

export const linkExpired = (data) => {
    const { linkExpired } = data;

    return {
        type: LINK_EXPIRED,
        gpc: { linkExpired: linkExpired },
    }
};
